import React from 'react';
import DashboardHeader from '../include/DashboardHeader';
import DashboardSidebar from '../include/DashboardSidebar';
import DashboardTitle from './dashboard_modules/DashboardTitle';
import thankyou_icon from '../../assets/images/thankyou_icon.svg';
import {useLocation} from 'react-router-dom';

import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap'

function Thankyou() {
  const location = useLocation();
    console.log(location);
  return (
    <div className='main-page bg4'>
      <DashboardHeader />
      <DashboardSidebar />

      <section className='main-section'>
        <div className='main-inner'>

          <DashboardTitle />

          <div className='thankyou-page'>
            <div className='white_box thankyou-inn'>
              <div className='thankyou-innbox'>

                <div className='block-title text-center'>
                  <i className='thankyou-iconbox d-flex'><img src={thankyou_icon} alt='' /></i>
                  <h1 className='h2'>Thank You</h1>
                  <p>Thank you for scheduling an appointment with us. Your appointment confirmation, along with the scheduled time,
                    will be sent to you shortly via the number  {location.state?.mobile_no ?? "8888880087"}.</p>
                </div>
                {location.state != null &&
                  <div className='table-block entry-content'>
                  <Table>
                    <tbody>
                      <tr>
                        <td>Location Name</td>
                        <td>{location.state.clinic_name}</td>
                      </tr>
                      <tr>
                        <td>Address</td>
                        <td>{location.state.clinic_address}</td>
                      </tr>
                      <tr>
                        <td>Map Link</td>
                        <td>
                          <Link to={location.state.map_link} target='_blank'>{location.state.map_link}</Link>
                        </td>
                      </tr>
                      <tr>
                        <td>Appointment Date</td>
                        <td>{location.state.schedule_date}</td>
                      </tr>
                      <tr>
                        <td>Appointment Time</td>
                        <td>
                          {location.state.schedule_from_time && location.state.schedule_to_time
                              ? `${location.state.schedule_from_time} - ${location.state.schedule_to_time}`
                              : "Appointment time will be confirmed by Eugenix team"}
                        </td>
                      </tr>
                    </tbody>
                  </Table>

                </div>
                }
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  )
}
export default Thankyou